import { render, staticRenderFns } from "./searchProducts.vue?vue&type=template&id=df7a1996&scoped=true&"
import script from "./searchProducts.vue?vue&type=script&lang=js&"
export * from "./searchProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7a1996",
  null
  
)

export default component.exports